import { render, staticRenderFns } from "./ContentVerifiedEmail.vue?vue&type=template&id=6aaa7702&scoped=true&"
import script from "./ContentVerifiedEmail.vue?vue&type=script&lang=js&"
export * from "./ContentVerifiedEmail.vue?vue&type=script&lang=js&"
import style0 from "./ContentVerifiedEmail.vue?vue&type=style&index=0&id=6aaa7702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa7702",
  null
  
)

export default component.exports